import {
  EXTERNAL_ROLES,
  type PredefinedRole,
} from "constants/predefined-roles.constants";

/**
 * Returns true only for values exactly matching one of `EXTERNAL_ROLES`.
 * Free-text legacy values, empty strings, `undefined`, and `null` all
 * return false — used to gate the role-selection modal at login.
 */
export const isPredefinedRole = (
  value: string | undefined | null,
): value is PredefinedRole =>
  !!value && (EXTERNAL_ROLES as readonly string[]).includes(value);
